var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterLockIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Component 168 \\u2013 4",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 23145",
    fill: "#deaa0c"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15144",
    d: "M21.26 1.492h-9.545v2.141h9.01v3.266l-7.496 5.943v7.816l-2.677-.642v-5.22H8.411v5.7a1.66 1.66 0 0 0 1.231 1.606l3.747.8h.375a1.629 1.629 0 0 0 1.606-1.606v-7.437l6.906-5.461a1.5 1.5 0 0 0 .589-1.231V3.098a1.606 1.606 0 0 0-1.605-1.606Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15142",
    d: "M11.167 12.199V6.846A1.071 1.071 0 0 0 10.1 5.773h-.535V4.704a3.212 3.212 0 1 0-6.424 0v1.069H2.6a1.07 1.07 0 0 0-1.071 1.071v5.354A1.071 1.071 0 0 0 2.6 13.273h7.5a1.071 1.071 0 0 0 1.067-1.074Zm-5.889-7.5a1.071 1.071 0 0 1 2.141 0v1.074H5.278Zm3.748 6.424H3.672V7.916h5.354Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterLockIcon);
export default __webpack_public_path__ + "static/media/filterLockIcon.65cc91d0b94d911dd12ba9a5528d9668.svg";
export { ForwardRef as ReactComponent };